import { Action } from '../../actions';
import {
  firstReferenceFromReferenceList,
  mergeEntities,
  transformObjects,
} from '../../helpers';

import { transformUserRecentProjectsAndContests } from './recent-project-and-contests.transformers';

export function navigationUserRecentProjectsAndContestsReducer(
  state = {},
  action: Action,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === 'navigationUserRecentProjectsAndContests') {
        const { result, refList } = action.payload;
        return mergeEntities<'navigationUserRecentProjectsAndContests'>(
          state,
          transformObjects(result.list, transformUserRecentProjectsAndContests),
          firstReferenceFromReferenceList(refList),
        );
      }
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/de/webapp/src/app/@shared/datastore/navigation/recent-projects-and-contests/recent-projects-and-contests.reducer.ts